export default __webpack_public_path__ + "static/media/taxi.ab4a15e9.png";